function get<T>(key: string): T | null {
  try {
    const value = localStorage.getItem(key) ?? '';
    // if(import.meta.env.MODE === 'development') console.log(`store/${key} (GET) => ${value || 'null'}`);
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
}

function set<T>(key: string, value: T): void {
  const strValue = JSON.stringify(value);
  // if(import.meta.env.MODE === 'development') console.log(`store/${key} (SET) => ${value || 'null'}`);
  localStorage.setItem(key, strValue);
}

function remove(key: string): void {
  localStorage.removeItem(key);
}

export default {
  get,
  set,
  remove,
};
